import IWall from 'components/interfaces/IWall';
import store from 'store/store';

import copyWall from '../propertiesBar/services/copyWall';
import glassWallPartTypes from '../types/glassWallPartTypes';
import getDefaultWall from './getDefaultWall';

const getFirstNotNullOrEmpty = (options: any) => {
  const firstNotNullOrEmpty = options.find(
    (option: any) => option !== null && option !== ''
  );

  return firstNotNullOrEmpty === undefined ? '' : firstNotNullOrEmpty;
};

const getExistingEditableWall = (selectedWall: any): IWall => {
  if (selectedWall.wallComponents === undefined) {
    const { previous } = store.getState().selectedWall;

    if (previous !== null) {
      return {
        ...copyWall(previous, true),
        buildingWallColor: selectedWall.properties.buildingWallColor,
        dimensionSide: selectedWall.properties.dimensionSide,
        endAngle: selectedWall.properties.endAngle,
        length: selectedWall.properties.length,
        perpendicularConnectionEnd:
          selectedWall.properties.perpendicularConnectionEnd,
        perpendicularConnectionStart:
          selectedWall.properties.perpendicularConnectionStart,
        roofHeight: selectedWall.properties.roofHeight,
        roofType: selectedWall.properties.roofType,
        startAngle: selectedWall.properties.startAngle,
        thickness: selectedWall.properties.thickness,
        wallDirection: selectedWall.properties.wallDirection,
        wallID: selectedWall.properties.wallID,
        wallType: selectedWall.properties.wallType,
      };
    }
  }

  const defaultWall = getDefaultWall();

  let parts =
    selectedWall.properties.parts === undefined
      ? []
      : selectedWall.properties.parts.map((part: any) => ({ ...part }));

  parts = parts.map((part: any) => {
    if (part.type === glassWallPartTypes.door) {
      if (part.doorGlassType === undefined) {
        // This is for handling old configurations that don't have the door
        // glass type in doors but only in walls. This can be removed when
        // it is unlikely enough that configurations like that exist.
        // - Robert, 2021-06-10
        part.doorGlassType = selectedWall.properties.doorGlassType;
      }
    }

    return part;
  });

  const buildingWallColor = getFirstNotNullOrEmpty([
    selectedWall.properties.buildingWallColor,
    defaultWall.buildingWallColor,
  ]);

  const profileColor = getFirstNotNullOrEmpty([
    selectedWall.properties.profileColor,
    defaultWall.profileColor,
  ]);

  const positionOffset = -selectedWall.properties.positionOffset;

  return {
    ...defaultWall,
    ...selectedWall.properties,
    buildingWallColor,
    parts,
    positionOffset,
    profileColor,
  };
};

export default getExistingEditableWall;
